import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-d",
  "use": "arrow-d-usage",
  "viewBox": "0 0 20 11.1",
  "content": "<symbol viewBox=\"0 0 20 11.1\" id=\"arrow-d\"><title>arrow-d</title><path d=\"M11,15.08a1.22,1.22,0,0,1-1,.46c-.36.06-.7-.22-1-.46L.33,6.38a1.13,1.13,0,0,1,1.6-1.6L10,13.06l8.08-8.28a1.13,1.13,0,1,1,1.6,1.6Zm0,0\" transform=\"translate(0 -4.45)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrow-d.svg
// module id = p06T
// module chunks = 264